import { pricingPageUrl } from '@/environment';
import flashLightning from '@/images/FlashLightning.svg';
import stars from '@/images/Stars.svg';
import { useAnalytics } from '@/services/analytics';
import { useFlag } from '@/services/featureFlags';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';
import CtaBanner from './CtaBanner';
import { useAppBanner } from './hooks';

export const CreditsFinishingBanner = () => {
    const { close } = useAppBanner();
    const creditsToMinutesEnabled = useFlag('credits_to_minutes_enabled', false);

    const mixpanel = useAnalytics();

    const handleCta = () => {
        window.open(pricingPageUrl, '_blank');
        mixpanel?.track('upgrade-package', { event: 'click', from: 'credits-finishing-banner' });
        close();
    };

    return (
        <CtaBanner
            title={creditsToMinutesEnabled ? 'Low on minutes?' : 'Low on credits?'}
            subtitle="Increase your limit by upgrading your package"
            ctaText="Upgrade"
            onCta={handleCta}
            ctaIcon={<MaskedIcon src={flashLightning} size="20px" />}
            icon={<MaskedIcon src={stars} size="20px" />}
        />
    );
};
